module.exports = __webpack_public_path__ + "img/aliyun.a484e2f9.png";